import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const ax = axios.create({ baseURL: process.env.REACT_APP_API_URL || '', withCredentials: true });

// ─── PRODUITS AXISPME.CA ──────────────────────────────────────────────────────
const AXISPME_ITEMS = [
  { name: 'Rapport SEO Essentiel — axispme.ca',          category: 'audit',  price: 299,  unit: 'fixe', description: 'Score /100, problèmes techniques détectés, recommandations SEO · Livré par email' },
  { name: 'Rapport SEO Pro + Consultation — axispme.ca', category: 'audit',  price: 499,  unit: 'fixe', description: 'Rapport Essentiel + appel vidéo 60 min avec expert · Priorités et plan d\'action' },
  { name: 'Audit Fiche Google My Business — axispme.ca', category: 'audit',  price: 199,  unit: 'fixe', description: 'Score GMB /100, analyse avis/photos/horaires, plan d\'action IA · Livré par email' },
  { name: 'Analyse Concurrentielle — axispme.ca',        category: 'audit',  price: 599,  unit: 'fixe', description: 'Comparaison vs 2–3 concurrents : scores SEO, PageSpeed, 10 critères, plan d\'action IA' },
  { name: 'Site Web React sur mesure — axispme.ca',      category: 'web',    price: 1299, unit: 'fixe', description: 'Design sur mesure, React ultra-rapide, SEO inclus, responsive, hébergement 1er mois inclus · Livré en 5–10 jours' },
  { name: 'Logo IA (2 concepts) — axispme.ca',           category: 'design', price: 49,   unit: 'fixe', description: '2 logos haute résolution générés par IA (Moderne + Créatif), fond blanc · Livré par email en 2–5 min' },
];

// ─── CATALOGUE PAR DÉFAUT ─────────────────────────────────────────────────────
const SEED_ITEMS = [
  // Produits axispme.ca (toujours en premier)
  ...AXISPME_ITEMS,

  // Design Graphique
  { name: 'Logo — Forfait Découverte',                   category: 'design',     price: 299,   unit: 'fixe',        description: 'Conception logo simple, 2 propositions, 1 révision' },
  { name: 'Logo — Forfait Standard',                     category: 'design',     price: 499,   unit: 'fixe',        description: '3 propositions, 3 révisions, fichiers sources' },
  { name: 'Logo — Forfait Premium',                      category: 'design',     price: 799,   unit: 'fixe',        description: 'Variations couleur/NB, guide utilisation, tous formats' },
  { name: 'Charte graphique complète',                   category: 'design',     price: 1199,  unit: 'fixe',        description: 'Couleurs, typographies, règles visuelles, exemples' },
  { name: 'Identité visuelle complète',                  category: 'design',     price: 899,   unit: 'fixe',        description: 'Logo + cartes d\'affaire + papier à en-tête' },
  { name: 'Carte d\'affaire (conception)',               category: 'design',     price: 149,   unit: 'fixe',        description: 'Recto/verso, prêt à imprimer' },
  { name: 'Papier à en-tête',                            category: 'design',     price: 99,    unit: 'fixe',        description: 'Gabarit Word/PDF inclus' },
  { name: 'Signature courriel HTML',                     category: 'design',     price: 79,    unit: 'fixe',        description: 'Compatible Outlook, Gmail, Apple Mail' },
  { name: 'Affiche événementielle',                      category: 'design',     price: 249,   unit: 'fixe',        description: 'Formats personnalisés, prêt impression' },
  { name: 'Flyer / Tract',                               category: 'design',     price: 99,    unit: 'fixe',        description: 'Format 4×6 ou 5.5×8.5 po' },
  { name: 'Dépliant 3 volets',                           category: 'design',     price: 199,   unit: 'fixe',        description: 'Conception recto/verso, gabarit impression' },
  { name: 'Menu restaurant',                             category: 'design',     price: 299,   unit: 'fixe',        description: 'Multi-pages, design sur mesure' },
  { name: 'Bannière publicitaire web (×3 formats)',      category: 'design',     price: 149,   unit: 'fixe',        description: 'Leaderboard, rectangle, carré' },
  { name: 'Pack contenu réseaux sociaux (×5 posts)',     category: 'design',     price: 149,   unit: 'fixe',        description: 'Formats carrés + stories adaptés' },

  // Impression Grand Format — Vinyle
  { name: 'Vinyle adhésif simple',                       category: 'vinyl',      price: 8,     unit: 'pi2',         description: 'Impression pleine couleur, intérieur/extérieur' },
  { name: 'Vinyle adhésif contrecollé',                  category: 'vinyl',      price: 12,    unit: 'pi2',         description: 'Substrate rigide, longue durée extérieur' },
  { name: 'Vinyle perforé (fenêtre)',                    category: 'vinyl',      price: 14,    unit: 'pi2',         description: 'Vision de l\'intérieur préservée' },
  { name: 'Vinyle décoration intérieure',                category: 'vinyl',      price: 10,    unit: 'pi2',         description: 'Repositionnable, textures disponibles' },
  { name: 'Lettre découpée en vinyle',                   category: 'vinyl',      price: 5,     unit: 'po_lin',      description: 'Monochrome, découpe de précision' },
  { name: 'Enseigne vinyle (jusqu\'à 4×8 pi)',           category: 'vinyl',      price: 349,   unit: 'fixe',        description: 'Impression + installation de base incluse' },
  { name: 'Bannière vinyle + œillets (2×4 pi)',          category: 'vinyl',      price: 129,   unit: 'fixe',        description: 'Format standard, cordons disponibles' },
  { name: 'Bannière grand format',                       category: 'vinyl',      price: 8,     unit: 'pi2',         description: 'Minimum 4 pi², œillets inclus' },
  { name: 'Vinyle magnétique véhicule (paire)',          category: 'vinyl',      price: 199,   unit: 'fixe',        description: 'Format standard 12×18 po par panneau' },
  { name: 'Wrap véhicule partiel',                       category: 'vinyl',      price: 799,   unit: 'fixe',        description: 'Capot, portes ou toit — conception incluse' },
  { name: 'Wrap véhicule complet',                       category: 'vinyl',      price: 1999,  unit: 'fixe',        description: 'Véhicule standard, conception incluse' },
  { name: 'Roll-up / Oriflamme',                         category: 'vinyl',      price: 249,   unit: 'fixe',        description: 'Impression + support inclus' },

  // Impression Standard
  { name: 'Cartes d\'affaire (500u)',                    category: 'impression', price: 99,    unit: 'fixe',        description: '14pt, finition glacée ou mate, recto/verso' },
  { name: 'Flyer 4×6 po (500u)',                         category: 'impression', price: 89,    unit: 'fixe',        description: 'Impression couleur pleine page' },
  { name: 'Affiche 11×17 (50u)',                         category: 'impression', price: 149,   unit: 'fixe',        description: 'Papier 100lb, couleur pleine page' },
  { name: 'Affiche 18×24 (25u)',                         category: 'impression', price: 189,   unit: 'fixe',        description: 'Format standard événementiel' },
  { name: 'Affiche 24×36 (10u)',                         category: 'impression', price: 179,   unit: 'fixe',        description: 'Grand format, papier photo' },
  { name: 'Dépliant 3 volets 8.5×11 (500u)',             category: 'impression', price: 249,   unit: 'fixe',        description: 'Pliage accordéon ou lettre' },
  { name: 'Menu plastifié (50u)',                         category: 'impression', price: 199,   unit: 'fixe',        description: 'Plastification recto/verso résistante' },

  // Conception Web
  { name: 'Landing page 1 page',                        category: 'web',        price: 799,   unit: 'fixe',        description: 'Design responsive, formulaire contact inclus' },
  { name: 'Site vitrine 3–5 pages',                     category: 'web',        price: 1499,  unit: 'fixe',        description: 'CMS simple, responsive, SEO de base' },
  { name: 'Site vitrine avancé (jusqu\'à 10 pages)',    category: 'web',        price: 2499,  unit: 'fixe',        description: 'Animation, multilingue optionnel, blog' },
  { name: 'Boutique e-commerce',                        category: 'web',        price: 3499,  unit: 'fixe',        description: 'Panier, paiement en ligne, gestion inventaire' },
  { name: 'Application web sur mesure',                 category: 'web',        price: null,  unit: 'sur_devis',   description: 'Devis selon cahier des charges' },
  { name: 'Refonte / Redesign de site',                 category: 'web',        price: 999,   unit: 'fixe',        description: 'À partir de l\'existant, nouveau design' },
  { name: 'Ajout de page / section',                    category: 'web',        price: 299,   unit: 'fixe',        description: 'Intégration dans site existant' },
  { name: 'Formulaire / intégration API',               category: 'web',        price: 199,   unit: 'fixe',        description: 'Formulaire avancé ou connecteur tiers' },
  { name: 'Hébergement + domaine',                      category: 'web',        price: 199,   unit: 'annuel',      description: 'DNS, SSL, hébergement infogéré' },
  { name: 'Maintenance mensuelle',                      category: 'web',        price: 99,    unit: 'mensuel',     description: 'Mises à jour, sauvegardes, support' },
  { name: 'Optimisation SEO de base',                   category: 'web',        price: 299,   unit: 'fixe',        description: 'Balises, vitesse, Google Search Console' },

  // Marketing & Réseaux Sociaux
  { name: 'Configuration réseaux sociaux',              category: 'marketing',  price: 149,   unit: 'fixe',        description: 'Création + optimisation du profil' },
  { name: 'Gestion mensuelle (3 posts/sem)',             category: 'marketing',  price: 399,   unit: 'mensuel',     description: 'Création contenu + planification + stats' },
  { name: 'Pack contenu (5 posts)',                      category: 'marketing',  price: 199,   unit: 'fixe',        description: 'Rédaction + visuels inclus' },
  { name: 'Pack Stories (10 stories)',                   category: 'marketing',  price: 149,   unit: 'fixe',        description: 'Animées ou statiques, formats adaptés' },
  { name: 'Setup campagne Google / Meta Ads',            category: 'marketing',  price: 299,   unit: 'fixe',        description: 'Création campagne, ciblage, pixel' },
];

// ─── CATÉGORIES ───────────────────────────────────────────────────────────────
const CATEGORIES = [
  { v: 'audit',      l: 'Scan & Audit Numérique',        color: '#f59e0b' },
  { v: 'design',     l: 'Design Graphique',              color: '#a78bfa' },
  { v: 'vinyl',      l: 'Impression Grand Format',       color: '#f472b6' },
  { v: 'impression', l: 'Impression Standard',           color: '#fb923c' },
  { v: 'web',        l: 'Conception Web',                color: '#60a5fa' },
  { v: 'marketing',  l: 'Marketing & Réseaux Sociaux',   color: '#4ade80' },
];

const UNITS = [
  { v: 'fixe',      l: 'Prix fixe'     },
  { v: 'pi2',       l: '/ pi²'         },
  { v: 'po_lin',    l: '/ po linéaire' },
  { v: 'mensuel',   l: '/ mois'        },
  { v: 'annuel',    l: '/ an'          },
  { v: 'sur_devis', l: 'Sur devis'     },
];

const EMPTY = { name: '', category: 'design', price: '', unit: 'fixe', description: '', active: true };

// ─── HELPERS ─────────────────────────────────────────────────────────────────
const cat  = v => CATEGORIES.find(c => c.v === v) || { l: v, color: '#888' };
const unit = v => UNITS.find(u => u.v === v) || { l: v };

function fmtPrice(price, u) {
  if (u === 'sur_devis' || price === null || price === undefined || price === '') return 'Sur devis';
  const n = parseFloat(price);
  if (isNaN(n)) return 'Sur devis';
  const uLabel = unit(u).l;
  return `${n.toLocaleString('fr-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: 0 })} ${uLabel !== 'Prix fixe' ? uLabel : ''}`.trim();
}

// ─── STYLES ──────────────────────────────────────────────────────────────────
const s = {
  page:     { color: '#F0F0F0', minHeight: '100%' },
  header:   { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 28, flexWrap: 'wrap', gap: 12 },
  h1:       { fontSize: '1.4rem', fontWeight: 800, color: '#EAEAEA', letterSpacing: '-0.02em', margin: 0 },
  sub:      { margin: '4px 0 0', color: '#555', fontSize: '0.82rem' },
  card:     { background: '#111', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 14, overflow: 'hidden' },
  th:       { padding: '10px 14px', fontSize: '0.68rem', fontWeight: 700, color: '#555', letterSpacing: '0.08em', textTransform: 'uppercase', textAlign: 'left', borderBottom: '1px solid rgba(255,255,255,0.05)', background: '#0e0e12' },
  td:       { padding: '12px 14px', borderBottom: '1px solid rgba(255,255,255,0.04)', verticalAlign: 'middle' },
  inp:      { width: '100%', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 8, padding: '10px 12px', color: '#EAEAEA', fontSize: '0.88rem', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' },
  lbl:      { display: 'block', fontSize: '0.7rem', color: '#555', marginBottom: 5, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase' },
  btnPri:   { display: 'inline-flex', alignItems: 'center', gap: 7, background: '#C8FF00', color: '#000', border: 'none', padding: '9px 20px', borderRadius: 8, fontWeight: 800, fontSize: '0.82rem', cursor: 'pointer' },
  btnGhost: { display: 'inline-flex', alignItems: 'center', gap: 7, background: 'transparent', color: '#555', border: '1px solid rgba(255,255,255,0.08)', padding: '9px 18px', borderRadius: 8, fontWeight: 600, fontSize: '0.82rem', cursor: 'pointer' },
  btnSeed:  { display: 'inline-flex', alignItems: 'center', gap: 7, background: 'transparent', color: '#a78bfa', border: '1px solid rgba(167,139,250,0.3)', padding: '9px 18px', borderRadius: 8, fontWeight: 700, fontSize: '0.82rem', cursor: 'pointer' },
};

// ─── ICÔNES ──────────────────────────────────────────────────────────────────
const IPlus = () => <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IPen  = () => <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const IBin  = () => <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>;
const ISeed = () => <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M12 22V12"/><path d="M5 7s1-6 7-4c0 0 4 2 0 9"/><path d="M19 7s-1-6-7-4c0 0-4 2 0 9"/></svg>;

function IconBtn({ icon, onClick, danger }) {
  const [hov, setHov] = useState(false);
  return (
    <button onClick={onClick}
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 28, height: 28, borderRadius: 6, border: `1px solid ${danger ? (hov ? 'rgba(248,113,113,0.5)' : 'rgba(248,113,113,0.2)') : (hov ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.07)')}`, background: 'transparent', color: danger ? (hov ? '#fca5a5' : '#f87171') : (hov ? '#EAEAEA' : '#555'), cursor: 'pointer', transition: 'all 0.15s', flexShrink: 0 }}>
      {icon}
    </button>
  );
}

// ─── MODAL ITEM ───────────────────────────────────────────────────────────────
function ItemModal({ item, onClose, onSave, saving }) {
  const [form, setForm] = useState(item || EMPTY);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const isDevis = form.unit === 'sur_devis';

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(8px)', zIndex: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }} onClick={onClose}>
      <div style={{ background: '#0e0e12', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 16, padding: 32, width: '100%', maxWidth: 560, maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 800, color: '#EAEAEA' }}>{item?.id ? 'Modifier l\'item' : 'Nouvel item'}</h3>
          <button style={{ background: 'none', border: 'none', color: '#555', cursor: 'pointer', fontSize: '1.5rem', lineHeight: 1 }} onClick={onClose}>×</button>
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={s.lbl}>Nom de l'item</label>
          <input style={s.inp} value={form.name} onChange={e => set('name', e.target.value)} placeholder="ex: Logo — Forfait Standard" />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
          <div>
            <label style={s.lbl}>Catégorie</label>
            <select style={{ ...s.inp, appearance: 'none', cursor: 'pointer' }} value={form.category} onChange={e => set('category', e.target.value)}>
              {CATEGORIES.map(c => <option key={c.v} value={c.v} style={{ background: '#111' }}>{c.l}</option>)}
            </select>
          </div>
          <div>
            <label style={s.lbl}>Unité / type de prix</label>
            <select style={{ ...s.inp, appearance: 'none', cursor: 'pointer' }} value={form.unit} onChange={e => set('unit', e.target.value)}>
              {UNITS.map(u => <option key={u.v} value={u.v} style={{ background: '#111' }}>{u.l}</option>)}
            </select>
          </div>
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={s.lbl}>Prix {isDevis ? '(non applicable)' : '($)'}</label>
          <input
            style={{ ...s.inp, opacity: isDevis ? 0.4 : 1 }}
            type="number" min="0" step="0.01"
            value={isDevis ? '' : (form.price ?? '')}
            onChange={e => set('price', e.target.value)}
            placeholder={isDevis ? 'Sur devis' : '0.00'}
            disabled={isDevis}
          />
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={s.lbl}>Description</label>
          <textarea style={{ ...s.inp, minHeight: 72, resize: 'vertical' }} value={form.description} onChange={e => set('description', e.target.value)} placeholder="Détails inclus, spécifications..." />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
          <button onClick={() => set('active', !form.active)} style={{ width: 40, height: 22, borderRadius: 11, background: form.active ? '#C8FF00' : 'rgba(255,255,255,0.08)', border: 'none', cursor: 'pointer', transition: 'background 0.2s', position: 'relative', flexShrink: 0 }}>
            <span style={{ position: 'absolute', top: 3, left: form.active ? 20 : 3, width: 16, height: 16, borderRadius: '50%', background: form.active ? '#000' : '#444', transition: 'left 0.2s' }} />
          </button>
          <span style={{ fontSize: '0.82rem', color: form.active ? '#C8FF00' : '#555' }}>{form.active ? 'Actif' : 'Inactif'}</span>
        </div>

        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 24, paddingTop: 20, borderTop: '1px solid rgba(255,255,255,0.05)' }}>
          <button style={s.btnGhost} onClick={onClose}>Annuler</button>
          <button style={{ ...s.btnPri, opacity: saving ? 0.6 : 1 }} onClick={() => onSave(form)} disabled={saving}>
            {saving ? 'En cours...' : 'Enregistrer'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── COMPOSANT PRINCIPAL ──────────────────────────────────────────────────────
export default function ItemsSection() {
  const [items,        setItems]        = useState([]);
  const [loading,      setLoading]      = useState(true);
  const [modal,        setModal]        = useState(null);
  const [saving,       setSaving]       = useState(false);
  const [delTarget,    setDelTarget]    = useState(null);
  const [search,       setSearch]       = useState('');
  const [catFilter,    setCatFilter]    = useState('all');
  const [seeding,      setSeeding]      = useState(false);
  const [importing,    setImporting]    = useState(false);
  const [viewMode,     setViewMode]     = useState('list'); // 'list' | 'table'

  const fetchItems = useCallback(async () => {
    try {
      const { data } = await ax.get('/api/items');
      return Array.isArray(data) ? data : [];
    } catch { return []; }
  }, []);

  const autoSeed = useCallback(async () => {
    setSeeding(true);
    try {
      for (const item of SEED_ITEMS) { await ax.post('/api/items', item); }
      localStorage.setItem('items-catalogue-seeded', '1');
      const data = await fetchItems();
      setItems(data);
    } finally { setSeeding(false); }
  }, [fetchItems]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const data = await fetchItems();
      if (data.length === 0 && !localStorage.getItem('items-catalogue-seeded')) {
        await autoSeed();
      } else {
        setItems(data);
      }
      setLoading(false);
    })();
  }, [fetchItems, autoSeed]);

  const reload = useCallback(async () => {
    const data = await fetchItems();
    setItems(data);
  }, [fetchItems]);

  const handleSave = useCallback(async (form) => {
    if (!form.name?.trim()) return;
    setSaving(true);
    try {
      const payload = {
        ...form,
        price: form.unit === 'sur_devis' ? null : (form.price !== '' ? parseFloat(form.price) : null),
      };
      if (form.id) { const { id, ...d } = payload; await ax.put(`/api/items/${id}`, d); }
      else { await ax.post('/api/items', payload); }
      setModal(null);
      reload();
    } finally { setSaving(false); }
  }, [reload]);

  const handleDelete = useCallback(async (item) => {
    await ax.delete(`/api/items/${item.id}`);
    setDelTarget(null);
    reload();
  }, [reload]);

  const handleToggleActive = useCallback(async (item) => {
    await ax.put(`/api/items/${item.id}`, { active: !item.active });
    reload();
  }, [reload]);

  const handleImportAxispme = useCallback(async () => {
    setImporting(true);
    try {
      const existing = new Set(items.map(i => i.name));
      const missing = AXISPME_ITEMS.filter(i => !existing.has(i.name));
      if (missing.length === 0) { alert('Les produits AXISPME sont déjà tous dans le catalogue.'); return; }
      for (const item of missing) { await ax.post('/api/items', item); }
      await reload();
      setCatFilter('audit');
    } finally { setImporting(false); }
  }, [items, reload]);

  // ─── FILTRES ──
  const visible = items.filter(it => {
    const matchCat = catFilter === 'all' || it.category === catFilter;
    const q = search.toLowerCase();
    const matchSearch = !q || it.name?.toLowerCase().includes(q) || it.description?.toLowerCase().includes(q);
    return matchCat && matchSearch;
  });

  // Groupés par catégorie pour la vue liste
  const grouped = CATEGORIES.map(c => ({
    ...c,
    items: visible.filter(it => it.category === c.v),
  })).filter(g => g.items.length > 0);

  const stats = {
    total:  items.length,
    active: items.filter(i => i.active !== false).length,
    bycat:  CATEGORIES.map(c => ({ ...c, count: items.filter(i => i.category === c.v).length })),
  };

  if (loading || seeding) return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '80px 0', gap: 14 }}>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      <div style={{ width: 32, height: 32, border: '2px solid rgba(200,255,0,0.15)', borderTop: '2px solid var(--accent,#C8FF00)', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }}/>
      <div style={{ color: '#555', fontSize: '0.82rem' }}>{seeding ? `Import du catalogue par défaut…` : 'Chargement…'}</div>
    </div>
  );

  return (
    <div style={s.page}>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>

      {/* ─── EN-TÊTE ─── */}
      <div style={s.header}>
        <div>
          <h2 style={s.h1}>Catalogue d'items</h2>
          <p style={s.sub}>{stats.total} items · {stats.active} actifs</p>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          {/* Toggle vue */}
          <div style={{ display: 'flex', background: '#111', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 8, overflow: 'hidden' }}>
            {[['list','Liste'],['table','Tableau']].map(([v, l]) => (
              <button key={v} onClick={() => setViewMode(v)}
                style={{ padding: '7px 14px', border: 'none', background: viewMode === v ? 'rgba(255,255,255,0.07)' : 'transparent', color: viewMode === v ? '#EAEAEA' : '#555', fontSize: '0.75rem', fontWeight: 700, cursor: 'pointer', transition: 'all 0.15s' }}>
                {l}
              </button>
            ))}
          </div>
          <button
            onClick={handleImportAxispme}
            disabled={importing}
            style={{ display: 'inline-flex', alignItems: 'center', gap: 7, background: 'transparent', color: '#f59e0b', border: '1px solid rgba(245,158,11,0.35)', padding: '9px 16px', borderRadius: 8, fontWeight: 700, fontSize: '0.8rem', cursor: importing ? 'not-allowed' : 'pointer', opacity: importing ? 0.6 : 1 }}>
            {importing
              ? <><span style={{ display: 'inline-block', width: 11, height: 11, border: '2px solid #f59e0b', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }}/> Import…</>
              : <><svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg> Importer AXISPME</>
            }
          </button>
          <button style={s.btnPri} onClick={() => setModal({ ...EMPTY })}>
            <IPlus /> Nouvel item
          </button>
        </div>
      </div>

      {/* ─── STATS CATÉGORIES ─── */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 10, marginBottom: 24 }}>
        {stats.bycat.map(c => (
          <div key={c.v} onClick={() => setCatFilter(catFilter === c.v ? 'all' : c.v)}
            style={{ background: catFilter === c.v ? `rgba(${hexToRgb(c.color)}, 0.1)` : '#111', border: `1px solid ${catFilter === c.v ? c.color + '55' : 'rgba(255,255,255,0.06)'}`, borderRadius: 12, padding: '14px 16px', cursor: 'pointer', transition: 'all 0.15s' }}>
            <div style={{ fontSize: '1.5rem', fontWeight: 900, color: c.color, letterSpacing: '-0.03em', fontVariantNumeric: 'tabular-nums' }}>{c.count}</div>
            <div style={{ fontSize: '0.68rem', color: '#444', fontWeight: 700, marginTop: 3, textTransform: 'uppercase', letterSpacing: '0.05em', lineHeight: 1.3 }}>{c.l}</div>
          </div>
        ))}
      </div>

      {/* ─── BARRE RECHERCHE + FILTRES ─── */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 20, flexWrap: 'wrap', alignItems: 'center' }}>
        <div style={{ position: 'relative', flex: 1, minWidth: 200 }}>
          <svg width="15" height="15" fill="none" stroke="#555" strokeWidth="2" viewBox="0 0 24 24" style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
          <input style={{ ...s.inp, paddingLeft: 36 }} placeholder="Rechercher un item…" value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          <button onClick={() => setCatFilter('all')}
            style={{ padding: '6px 14px', borderRadius: 20, border: `1px solid ${catFilter === 'all' ? 'rgba(200,255,0,0.4)' : 'rgba(255,255,255,0.08)'}`, background: catFilter === 'all' ? 'rgba(200,255,0,0.1)' : 'transparent', color: catFilter === 'all' ? 'var(--accent,#C8FF00)' : '#666', fontSize: '0.75rem', fontWeight: 700, cursor: 'pointer' }}>
            Tous ({stats.total})
          </button>
          {CATEGORIES.map(c => (
            <button key={c.v} onClick={() => setCatFilter(catFilter === c.v ? 'all' : c.v)}
              style={{ padding: '6px 14px', borderRadius: 20, border: `1px solid ${catFilter === c.v ? c.color + '66' : 'rgba(255,255,255,0.08)'}`, background: catFilter === c.v ? c.color + '18' : 'transparent', color: catFilter === c.v ? c.color : '#666', fontSize: '0.75rem', fontWeight: 700, cursor: 'pointer' }}>
              {c.l}
            </button>
          ))}
        </div>
      </div>

      {visible.length === 0 && (
        <div style={{ padding: '48px', textAlign: 'center', color: '#444', fontSize: '0.88rem' }}>Aucun résultat pour cette recherche.</div>
      )}

      {/* ─── VUE LISTE groupée par catégorie ─── */}
      {viewMode === 'list' && visible.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          {grouped.map(grp => (
            <div key={grp.v} style={s.card}>
              {/* En-tête catégorie */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '14px 18px', borderBottom: '1px solid rgba(255,255,255,0.05)', background: 'rgba(255,255,255,0.02)' }}>
                <span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: grp.color, boxShadow: `0 0 8px ${grp.color}88`, flexShrink: 0 }}/>
                <span style={{ fontWeight: 800, color: grp.color, fontSize: '0.8rem', letterSpacing: '0.06em', textTransform: 'uppercase' }}>{grp.l}</span>
                <span style={{ marginLeft: 'auto', fontSize: '0.68rem', color: '#444', fontWeight: 700 }}>{grp.items.length} article{grp.items.length > 1 ? 's' : ''}</span>
              </div>
              {/* Items */}
              {grp.items.map((item, idx) => {
                const active = item.active !== false;
                return (
                  <div key={item.id}
                    style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '12px 18px', borderBottom: idx < grp.items.length - 1 ? '1px solid rgba(255,255,255,0.04)' : 'none', opacity: active ? 1 : 0.45, transition: 'background 0.1s' }}
                    onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.02)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    {/* Dot actif */}
                    <div style={{ width: 6, height: 6, borderRadius: '50%', background: active ? grp.color : '#333', flexShrink: 0 }}/>
                    {/* Nom + desc */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 700, color: '#EAEAEA', fontSize: '0.88rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.name}</div>
                      {item.description && (
                        <div style={{ fontSize: '0.72rem', color: '#444', marginTop: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.description}</div>
                      )}
                    </div>
                    {/* Unité */}
                    <span style={{ fontSize: '0.68rem', color: '#444', fontWeight: 600, whiteSpace: 'nowrap', flexShrink: 0 }}>{unit(item.unit).l}</span>
                    {/* Prix */}
                    <span style={{ fontWeight: 800, color: item.price ? grp.color : '#444', fontSize: '0.9rem', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap', minWidth: 100, textAlign: 'right', flexShrink: 0 }}>
                      {fmtPrice(item.price, item.unit)}
                    </span>
                    {/* Toggle + actions */}
                    <button onClick={() => handleToggleActive(item)}
                      title={active ? 'Désactiver' : 'Activer'}
                      style={{ width: 34, height: 18, borderRadius: 9, background: active ? 'var(--accent,#C8FF00)' : 'rgba(255,255,255,0.08)', border: 'none', cursor: 'pointer', position: 'relative', flexShrink: 0, transition: 'background 0.2s' }}>
                      <span style={{ position: 'absolute', top: 1, left: active ? 16 : 1, width: 16, height: 16, borderRadius: '50%', background: active ? '#000' : '#444', transition: 'left 0.2s' }}/>
                    </button>
                    <div style={{ display: 'flex', gap: 5, flexShrink: 0 }}>
                      <IconBtn icon={<IPen />} onClick={() => setModal(item)}/>
                      <IconBtn danger icon={<IBin />} onClick={() => setDelTarget(item)}/>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      )}

      {/* ─── VUE TABLEAU ─── */}
      {viewMode === 'table' && visible.length > 0 && (
        <div style={s.card}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={s.th}>Item</th>
                <th style={s.th}>Catégorie</th>
                <th style={s.th}>Prix</th>
                <th style={s.th}>Statut</th>
                <th style={s.th}></th>
              </tr>
            </thead>
            <tbody>
              {visible.map(item => {
                const c = cat(item.category);
                const active = item.active !== false;
                return (
                  <tr key={item.id}
                    onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.02)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                    style={{ transition: 'background 0.1s', opacity: active ? 1 : 0.45 }}>
                    <td style={s.td}>
                      <div style={{ fontWeight: 700, color: '#EAEAEA', fontSize: '0.88rem' }}>{item.name}</div>
                      {item.description && (
                        <div style={{ fontSize: '0.73rem', color: '#555', marginTop: 2 }}>
                          {item.description.length > 70 ? item.description.slice(0, 70) + '…' : item.description}
                        </div>
                      )}
                    </td>
                    <td style={s.td}>
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '3px 9px', borderRadius: 100, fontSize: '0.68rem', fontWeight: 700, color: c.color, background: c.color + '18', letterSpacing: '0.04em', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>
                        {c.l}
                      </span>
                    </td>
                    <td style={{ ...s.td, fontVariantNumeric: 'tabular-nums', fontWeight: 700, color: 'var(--accent,#C8FF00)', fontSize: '0.88rem', whiteSpace: 'nowrap' }}>
                      {fmtPrice(item.price, item.unit)}
                    </td>
                    <td style={s.td}>
                      <button onClick={() => handleToggleActive(item)}
                        style={{ width: 36, height: 20, borderRadius: 10, background: active ? 'var(--accent,#C8FF00)' : 'rgba(255,255,255,0.08)', border: 'none', cursor: 'pointer', transition: 'background 0.2s', position: 'relative' }}>
                        <span style={{ position: 'absolute', top: 2, left: active ? 18 : 2, width: 16, height: 16, borderRadius: '50%', background: active ? '#000' : '#444', transition: 'left 0.2s' }}/>
                      </button>
                    </td>
                    <td style={{ ...s.td, textAlign: 'right' }}>
                      <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
                        <IconBtn icon={<IPen />} onClick={() => setModal(item)}/>
                        <IconBtn danger icon={<IBin />} onClick={() => setDelTarget(item)}/>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* ─── MODAL ÉDITION ─── */}
      {modal && (
        <ItemModal
          item={modal}
          onClose={() => setModal(null)}
          onSave={handleSave}
          saving={saving}
        />
      )}

      {/* ─── CONFIRM SUPPRESSION ─── */}
      {delTarget && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(8px)', zIndex: 700, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setDelTarget(null)}>
          <div style={{ background: '#0e0e12', border: '1px solid rgba(248,113,113,0.2)', borderRadius: 14, padding: 28, maxWidth: 340, width: '90%', textAlign: 'center' }} onClick={e => e.stopPropagation()}>
            <div style={{ fontSize: '1.8rem', marginBottom: 10 }}>⚠</div>
            <div style={{ color: '#EAEAEA', fontWeight: 700, marginBottom: 6 }}>Supprimer "{delTarget.name}" ?</div>
            <div style={{ color: '#444', fontSize: '0.82rem', marginBottom: 22 }}>Action irréversible.</div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
              <button style={s.btnGhost} onClick={() => setDelTarget(null)}>Annuler</button>
              <button style={{ ...s.btnPri, background: '#f87171', color: '#fff' }} onClick={() => handleDelete(delTarget)}>Supprimer</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── UTILITAIRE HEX → RGB ─────────────────────────────────────────────────────
function hexToRgb(hex) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `${r}, ${g}, ${b}`;
}
